import Vue from 'vue';
import Component from 'vue-class-component';
import SketchfabFrame from '../sketchfabFrame/SketchfabFrame.vue';
import { Prop, Inject } from 'vue-property-decorator';
import { ConfiguratorService, ConfiguratorServiceSettings, HideObjectsCommand, FilterOperators } from '../../../services/sketchfab/index';
import { Store } from '@/store';
import { ServiceIdentifiers } from '@/services';
import { ComponentContainer } from '@/services/container';

import * as _ from 'lodash';
import ProductSelector from '@/components/productSelector/ProductSelector';
import { ProductDefinition, AnimationDefinition } from '@/models/configuratorx/configuratorSchema';
import Toggle from '@/components/parts/Toggle';

import PartsColor from '@/components/partsColor/PartsColor';


@Component({
  components: {
    toggle: Toggle,
    partsColor: PartsColor,
  },
})

export default class Ori9b extends Vue
{
  private _configuratorService: ConfiguratorService = undefined;


  @Inject()
  private _container: ComponentContainer;

  product: ProductDefinition;

  seletedArmletType: string = ReflexdArmletType.Adjustable;
  seletedFoot: string = FileFoot.Metal;
  seletedBack: string = OriBack.Ayarli;

  availableAnimations: AnimationDefinition[] = [];

  defHideObjects = [
    '_yyy',
    'kolcak_plastik',
  ];

  defShowObjects = [
    'xxx_ori_alt_yyy',
    'ori_9_sirt_yyy',
    'ori_ayak_plastik_yyy',
    'genisliksiz',
    'kizaksiz',
    'donati',
    'baslikli',
    'xxx_ori_kolcak_sag_yyy',
    'xxx_ori_kolcak_sol_yyy',
    'xxx_ori_kolcak_dugme_sag_yyy',
    'xxx_ori_kolcak_dugme_sol_yyy',
    'xxx_ori_braket_siyah_yyy',
  ];

  async created()
  {
    this.product = Store.getProductById('ori9b');
    this.product.partsPalettes = _.orderBy(this.product.partsPalettes, ['order'], ['asc']);
    this.availableAnimations = this.product.animations as any;
    this.availableAnimationsChanged();

    this._configuratorService = this._container.get<ConfiguratorService>(ServiceIdentifiers.ConfiguratorService);
    await this._configuratorService.hideObjects({ objects: this.defHideObjects, operator: FilterOperators.Contains });
    await this._configuratorService.showObjects({ objects: this.defShowObjects, operator: FilterOperators.Contains });


    if (Store.state.selection)
    {
      Store.state.selection.parts.forEach((element) =>
      {
        this.colorChanged(element.color, element.palette, element.id);
        this.colorChanged(element.color, element.palette, element.id);
      });
      if (Store.state.selection.footAndHand === FileFoot.Metal)
      {
        await this.changeFoot(FileFoot.Metal);
      }
      if (Store.state.selection.backrest === OriBack.Sabit)
      {
        await this.changeBack(OriBack.Sabit);
      }
      if (Store.state.selection.footAndHand === FileFoot.Plastik)
      {
        await this.changeFoot(FileFoot.Plastik);
        if (Store.state.selection.armletType === ReflexdArmletType.Constant)
        {
          await this.changeArmletType(ReflexdArmletType.Constant);
        }
      }
    } else
    {
      await this.applyDefaultSelection();
    }
  }

  availableAnimationsChanged()
  {
    this.$emit('availableAnimationsChanged', this.availableAnimations);
  }

  mounted()
  {
    // this.configuratorService = Store.state.configuratorService;
  }

  async applyDefaultSelection()
  {
    const selection = new Ori9Selection();
    selection.parts = [];
    selection.backrest = OriBack.Ayarli;
    selection.armletType = ReflexdArmletType.Adjustable;
    selection.footAndHand = FileFoot.Metal;
    
    this.product.defaults.parts.forEach((element) =>
    {
      this.colorChanged(element.color, element.palette, element.id);
      const part = new PartSelection();
      part.id = element.id;
      part.color = element.color;
      part.palette = element.palette;
      part.name = element.name;
      selection.parts.push(part);
    });

    Store.state.selection = selection;
    this.changeFoot(FileFoot.Metal);
  }

  async changeFoot(foot: FileFoot)
  {
    if (foot === FileFoot.Metal)
    {
      await this._configuratorService.hideObjects({ objects: ['ori_ayak_plastik_yyy', 'ori_kolcak_demir_genisliksiz_plastik_yyy', 'xxx_ori_braket_siyah_yyy', 'kolcak_plastik'], operator: FilterOperators.Contains });
      await this._configuratorService.showObjects({ objects: ['ori_ayak_metal_yyy', 'ori_kolcak_demir_genisliksiz_aluminyum_yyy', 'xxx_ori_braket_aluminyum_yyy', 'xxx_ori_kolcak'], operator: FilterOperators.Contains });
      Store.state.selection.footAndHand = FileFoot.Metal;
      this.seletedFoot = FileFoot.Metal;
      Store.state.selection.armletType = ReflexdArmletType.Adjustable;
      this.seletedArmletType = ReflexdArmletType.Adjustable;
      this.updateAnimations();
    }
    if (foot === FileFoot.Plastik)
    {
      await this._configuratorService.hideObjects({ objects: ['ori_ayak_metal_yyy', 'ori_kolcak_demir_genisliksiz_aluminyum_yyy', 'xxx_ori_braket_aluminyum_yyy', 'kolcak_plastik'], operator: FilterOperators.Contains });
      await this._configuratorService.showObjects({ objects: ['ori_ayak_plastik_yyy', 'ori_kolcak_demir_genisliksiz_plastik_yyy', 'xxx_ori_braket_siyah_yyy', 'xxx_ori_kolcak'], operator: FilterOperators.Contains });
      Store.state.selection.footAndHand = FileFoot.Plastik;
      this.seletedFoot = FileFoot.Plastik;
      this.updateAnimations();
      if (Store.state.selection.armletType === ReflexdArmletType.Constant)
      {
        await this.changeArmletType(ReflexdArmletType.Constant);
      }
    }
  }

  async changeArmletType(arm: ReflexdArmletType)
  {
    if (arm === ReflexdArmletType.Constant)
    {
      await this._configuratorService.showObjects({ objects: ['kolcak_plastik'], operator: FilterOperators.Contains });
      await this._configuratorService.hideObjects({ objects: ['ori_kolcak_demir_genisliksiz_plastik_yyy', 'ori_ayak_metal_yyy', 'ori_kolcak_demir_genisliksiz_aluminyum_yyy', 'xxx_ori_braket_aluminyum_yyy', 'xxx_ori_kolcak'], operator: FilterOperators.Contains });
      Store.state.selection.armletType = arm;
      this.seletedArmletType = arm;
      this.updateAnimations();

    }
    if (arm === ReflexdArmletType.Adjustable)
    {

      await this._configuratorService.hideObjects({ objects: ['kolcak_plastik'], operator: FilterOperators.Contains });
      await this._configuratorService.showObjects({ objects: ['ori_kolcak_demir_genisliksiz_plastik_yyy', 'xxx_ori_kolcak'], operator: FilterOperators.Contains });
      Store.state.selection.armletType = arm;
      this.seletedArmletType = arm;
      this.updateAnimations();
    }
  }

  async changeBack(back: OriBack)
  {
    if (back === OriBack.Ayarli)
    {
      Store.state.selection.backrest = OriBack.Ayarli;
      this.seletedBack = OriBack.Ayarli;
      this.updateAnimations();
    }
    if (back === OriBack.Sabit)
    {
      Store.state.selection.backrest = OriBack.Sabit;
      this.seletedBack = OriBack.Sabit;
      this.updateAnimations();
    }
  }

  updateAnimations()
  {
    let animations = [];

    if (this.seletedArmletType === ReflexdArmletType.Constant && this.seletedBack === OriBack.Sabit)
    {
      this.product.animations.forEach((element) =>
      {
        if (!(element.animationName === 'a5' || element.animationName === 'a1'))
        {
          animations.push(element);
        }
      });
    }

    else if (this.seletedArmletType === ReflexdArmletType.Adjustable && this.seletedBack === OriBack.Sabit)
    {
      this.product.animations.forEach((element) =>
      {
        if (!(element.animationName === 'a5'))
        {
          animations.push(element);
        }
      });
    }

    else if (this.seletedArmletType === ReflexdArmletType.Constant && this.seletedBack === OriBack.Ayarli)
    {
      this.product.animations.forEach((element) =>
      {
        if (!(element.animationName === 'a1'))
        {
          animations.push(element);
        }
      });
    }

    else if (this.seletedArmletType === ReflexdArmletType.Adjustable && this.seletedBack === OriBack.Ayarli)
    {
      animations = this.product.animations as any[];
    }

    this.availableAnimations = animations;
    this.availableAnimationsChanged();
  }

  async colorChanged(color: any, palette: any, part: any)
  {

    const getPart = this.product.partsPalettes.find(x => x.part === part);
    const getPalettes = Store.state.configuratorConfig.definitions.palettes.find(x => x.id === palette);
    const getColor = getPalettes.colors.find(col => col.name === color);
    await this._configuratorService.changeAlbedoPBR({
      materials: getPart.materials,
      texture: getColor.texture,
    });
    Store.state.selection.parts.find(x => x.id === part).palette = palette;
    Store.state.selection.parts.find(x => x.id === part).color = color;
  }
}


export class Ori9Selection
{
  footAndHand: FileFoot;
  backrest: OriBack;
  armletType: ReflexdArmletType;
  parts: PartSelection[];
}
export class PartSelection
{
  id: string;
  palette: string;
  name: string;
  color: string;
}
enum FileFoot
{
  Metal = 'metal',
  Plastik = 'plastik',
}
enum OriBack
{
  Ayarli = 'ayarli',
  Sabit = 'sabit',
}
enum ReflexdArmletType
{
  Constant = 'constant',
  Adjustable = 'adjustable',
}



// WEBPACK FOOTER //
// ./src/components/families/ori/Ori9b.ts